import React from "react";
import { Link } from "react-router-dom";

export default function Footer() {
    return (
        <footer className="w-full max-w-[1200px] mx-auto px-4 text-xs pb-[20px] text-gray-500 flex flex-col">
            <span className="text-[18px] font-['Jersey_10'] ">
                © Frankly Origins 2026 |{' '}
                <Link to="/privacy-policy" className="hover:text-gray-700 transition-colors">Privacy Policy</Link>
                {' '}|{' '}
                <Link to="/terms-of-service" className="hover:text-gray-700 transition-colors">Terms of Service</Link>
                {' '}|{' '}
                <Link to="/community-guidelines" className="hover:text-gray-700 transition-colors">Community Guidelines</Link>
                {' '}| Cookies |{' '}
                <a href="https://discord.gg/vehU36G44N" target="_blank" rel="noreferrer" className="hover:text-gray-700 transition-colors">Join Our Discord!</a>
                {' '}| Report Issues | Contact Us:{' '}
                <a href="mailto:hello@franklyorigins.net" target="_blank" rel="noreferrer" className="hover:text-gray-700 transition-colors">hello@franklyorigins.net</a>
            </span>
            <span>
                All Habbo-related imagery and assets used on this website, including but not limited to
                furniture icons and other graphics, are the property of Sulake Corporation Oy, the
                creator of Habbo. This website is not affiliated with, endorsed, sponsored, or
                specifically approved by Sulake Corporation Oy. All rights to these materials are
                reserved by their respective owners.
            </span>
        </footer>
    );
}